import { useDispatch, useSelector } from "react-redux";
import { searched } from "../../redux/filters/actions";
import Logo from "./../../assets/lws.svg";
import Search from "./../../assets/search.svg";

const debounce = (fn) => {
    let timing;

    return (...args) => {
        if (timing) {
            clearTimeout(timing);
        }
        timing = setTimeout(() => {
            fn(...args);
        }, 1000);
    };
};
const Header = () => {
    const input = useSelector((state) => state.filter.input);
    const dispatch = useDispatch();

    const handler = debounce((e) => {
        dispatch(searched(e.target.value));
    });

    console.log(input);
    return (
        <>
            <nav className="bg-slate-100 shadow-md">
                <div className="max-w-7xl mx-auto px-5 lg:px-0 flex justify-between py-3 items-center">
                    <a href="index.html">
                        <img
                            className="h-10"
                            src={Logo}
                            alt="Learn with Sumit"
                        />
                    </a>
                </div>
            </nav>
            <div className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200">
                <input
                    className="outline-none border-none bg-gray-50 h-full w-full mr-2"
                    type="search"
                    name="search"
                    placeholder="Search"
                    onChange={handler}
                />
                <img
                    className="inline h-6 cursor-pointer"
                    src={Search}
                    alt="Search"
                />
            </div>
        </>
    );
};

export default Header;
